<script setup>
import { nextTick } from 'process';
import { ref, onMounted, watch } from 'vue';
import { useCurrentMenuStore } from "../../stores/current-menu";
import MenuItemWineSize from './MenuItemWineSize';

const props = defineProps({
    currentMenuItem: { required: true },
    categoryIndex: { required: true },
    subcategoryIndex: { required: true },
    site: { required: true },
});

const currentMenuStore = useCurrentMenuStore();

const menuItem = ref();

const prices = [
    {
        "active": true,
        "size": "125ml",
        "price": 0,
        "price_id": null,
        "calories": null
    },
    {
        "active": true,
        "size": "175ml",
        "price": 0,
        "price_id": null,
        "calories": null
    },
    {
        "active": true,
        "size": "250ml",
        "price": 0,
        "price_id": null,
        "calories": null
    },
    {
        "active": true,
        "size": "Bottle",
        "price": 0,
        "price_id": null,
        "calories": null
    }
];

onMounted(() => {
    nextTick(() => {
        addWinePricing();
    });
});

watch(currentMenuStore.currentMenu.sites, () => {
    nextTick(() => {
        addWinePricing();
    });
});

function addWinePricing() {
    let menuItemIndex = currentMenuStore['drink'][props.categoryIndex].contents[props.subcategoryIndex].contents.findIndex(
        (item) => item.id === props.currentMenuItem
    );

    menuItem.value = currentMenuStore['drink'][props.categoryIndex].contents[props.subcategoryIndex].contents[menuItemIndex]

    if (!("wine_price" in currentMenuStore['drink'][props.categoryIndex].contents[props.subcategoryIndex].contents[menuItemIndex])) {
        currentMenuStore['drink'][props.categoryIndex].contents[props.subcategoryIndex].contents[menuItemIndex].wine_price = {};
    }

    if (!(props.site.id in currentMenuStore['drink'][props.categoryIndex].contents[props.subcategoryIndex].contents[menuItemIndex].wine_price)) {
        currentMenuStore['drink'][props.categoryIndex].contents[props.subcategoryIndex].contents[menuItemIndex].wine_price[props.site.id] = {
            active: true,
            id: props.site.id,
            prices: prices
        }
    }
}

</script>

<template>
    <div v-if="menuItem">
        <template v-if="menuItem.wine_price">
            <div class="flex">
                <input type="checkbox" v-model="menuItem.wine_price[site.id].active">
                <h3>{{ site.name }}</h3>
            </div>
            <div class="wine" v-for="(item, index) in menuItem.wine_price[site.id].prices">
                <MenuItemWineSize :item="item" :menuItem="menuItem"></MenuItemWineSize>
            </div>
        </template>
    </div>
</template>

<style lang="scss" scoped>
@import '../../../scss/partials/variables';

.wine {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media screen and (max-width: $breakpoint-sm) {
        gap: 2px;
        padding-top: 10px;

        div {
            width: 100%;
        }

        input[type='checkbox'] {
            margin-right: 10px;
        }
    }

    &__title {
        font-weight: bold;
        min-width: 55px;
    }

    .checkbox {
        display: flex;
        align-items: center;

        input {
            margin: 0 20px 0 0;
        }
    }
}

.flex {
    @media screen and (max-width: $breakpoint-lg) {
        margin-bottom: 10px;
    }
}

h3 {
    margin: 0;
}


input[type="number"] {
    width: 100px;
    appearance: none;
    margin-left: auto;
    margin-bottom: 0;
    text-align: right;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
    }
}
</style>